/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCoffeeTastingTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCoffeeTasting,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Sip and Savor!",
    "Coffee Lovers Unite!",
    "Taste the Bean!",
  ],
  title: "Coffee Tasting Event",
  description: "Organize a delightful coffee tasting experience.",
  longDescription:
    "Plan a cozy coffee tasting event. Choose a date, select the coffees to taste, and decide on pastries to enjoy with them!",
  emoji: "☕",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Coffee Tasting Event",
          emoji: "☕",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the coffee tasting?",
          emoji: "📅",
          completeAction: {
            question: "Decide on which coffees to taste?",
            description: "What coffees do we want to sample?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "Which coffees should we taste?",
                emoji: "🍵",
                completeAction: {
                  question: "Decide on pastries?",
                  description: "What pastries should we serve with the coffee?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What pastries should we bring?",
                      emoji: "🍰",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Cheers to Great Coffee!",
    outroDescription:
      "Your coffee tasting plans are set! Enjoy the aromas and flavors!",
  },
};
